import {backboneViewProperties} from "../../decorators/backbone-properties";
import {UserHistoryItemModel} from "../../user-history/models/user-history-item";
import Marionette from "../../shared/marionette-mustache";

const template = require<string>("../../user-history/views/user-history-item-empty.html");

@backboneViewProperties({
    template: template,
    tagName: "li",
    className: "history-item"
})
export class UserHistoryItemEmptyView extends Marionette.ItemView<UserHistoryItemModel> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/user-history/views/user-history-item-empty.ts